import {
	type AssetSchema,
	type AssetTypeSummary,
	type SystemType,
} from '@innovyze/lib_asset_schema';
import { type AssetPickerOptions } from '@innovyze/lib_asset_schema_react';
import {
	useImportedAssetTypes,
	useReleasedAssetPickerOptions,
} from '../../hooks/assetSchemaHooks';
import { supportedInspectionStandards } from './supportedInspectionStandards';

// Only offer asset types that can be rehab modelled (e.g. not Customer).
const REHAB_PICKER_RULE = { capability: 'Rehab' } as const;

// Released by the flag, imported by the tenant and rehab modellable.
const useRehabPickerOptions = () =>
	useReleasedAssetPickerOptions({
		...REHAB_PICKER_RULE,
		imported: useImportedAssetTypes(),
	});

export function useEnabledSystemTypes(): {
	enabledSystemTypes: readonly SystemType[];
	status: AssetPickerOptions['status'];
} {
	const { systemTypes, status } = useRehabPickerOptions();

	return { enabledSystemTypes: systemTypes, status };
}

export function useEnabledAssetTypes(systemType?: SystemType): {
	enabledAssetTypes: readonly AssetTypeSummary[];
} {
	const { assetTypesFor } = useRehabPickerOptions();

	if (!systemType) {
		return { enabledAssetTypes: [] };
	}

	return { enabledAssetTypes: assetTypesFor(systemType.id) };
}

export function useEnabledInspectionStandards(assetSchema?: AssetSchema): {
	enabledInspectionStandards: string[];
} {
	const inspectionStandards = assetSchema?.getInspectionTypes() ?? [];

	const enabledInspectionStandards = inspectionStandards.filter(standard => {
		return supportedInspectionStandards.includes(standard);
	});

	return { enabledInspectionStandards };
}
